import { all } from 'redux-saga/effects';
import authSaga from './auth.saga';
import ssoSaga from './sso.saga';

import {
  getNoConformidadesRequest,
  getNoConformidadRequest,
  crearNoConformidadRequest,
  actualizarNoConformidadRequest,
  eliminarFotoNoConformidadRequest,
} from './noconformidades/noconformidades.saga';
import { getClientesRequest } from './clientes/clientes.saga';
import { getProveedoresRequest } from './proveedores/proveedores.saga';
import { getRrhhRequest } from './rrhh/rrhh.saga';
import { getSedesRequest } from './sedes/sedes.saga';
import { getTipologiasRequest } from './tipologias/tipologias.saga';
import { getProcesosRequest } from './procesos/procesos.saga';
import { uploadPhotosRequest } from './sistemaSubidaFotografias/fotografias.saga';

export default function* rootSaga() {
  yield all([
    authSaga(),
    ssoSaga(),
    getNoConformidadesRequest(),
    getNoConformidadRequest(),
    crearNoConformidadRequest(),
    actualizarNoConformidadRequest(),
    getClientesRequest(),
    getProveedoresRequest(),
    getRrhhRequest(),
    getSedesRequest(),
    getTipologiasRequest(),
    getProcesosRequest(),
    uploadPhotosRequest(),
    eliminarFotoNoConformidadRequest(),
  ]);
}
